import { MODULE } from 'config/env'

export const showRemoteCupping = MODULE !== 'sca'
export const showBannerBetaVersion = MODULE === 'sca'
export const showSignUpPage = MODULE !== 'sca'
export const showAllLanguages = true
export const isScaModule = MODULE === 'sca'
export const isEventModule = MODULE === 'sca'
